var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlWakeUpServiceOutlined = function SvgHtlWakeUpServiceOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 8.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm1 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.27 2.507L7.661 8.868A.5.5 0 0 1 7.5 8.5V5.422a.5.5 0 0 1 1 0v2.872l1.981 2.011a.497.497 0 0 1 .014.726.5.5 0 0 1-.726-.026v.002Zm3.013-7.074-1.733-1a.5.5 0 0 1 .5-.866l1.733 1a.5.5 0 0 1-.5.866ZM2.567 3.749a.5.5 0 0 1 .184-.683l1.731-1a.5.5 0 0 1 .5.866l-1.732 1a.5.5 0 0 1-.683-.184v.001Z"
  })));
};
export default SvgHtlWakeUpServiceOutlined;